import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import TokenPresenter from './token-presenter';
import { useTranslation } from 'react-i18next';

const KEY_AUTH_CODE = 'code';
const KEY_ERROR = 'error';
const KEY_ERROR_REASON = 'error_reason';
const KEY_ERROR_DESC = 'error_description';

const ERROR_USER_DENIED = 'user_denied';

const CLIENT_ID = '2841908772774609';

export function extractFromUrl(key) {
  const url = new URL(window.location.href);
  const value = url.searchParams.get(key);
  delete url.searchParams.delete(key);
  window.history.replaceState({}, document.title, url.href);
  return value;
}

const REDIRECT_URI = process.env.REACT_APP_FACEBOOK_REDIRECT_URI || 'https://localhost:3000/facebook/';
const API_URL = process.env.REACT_APP_API_URI || 'https://dev-api.dsplay.tv';
const FACEBOOK_GRAPH_URI = 'https://graph.facebook.com/v20.0';

function Token() {

  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [userToken, setUserToken] = useState();
  const [success, setSuccess] = useState();
  const [name, setName] = useState();
  const [profilePictureUrl, setProfilePictureUrl] = useState();
  const [userPages, setUserPages] = useState([]);
  const [error, setError] = useState();

  const handleOnGenerate = useCallback(() => {
    const permissions = [
      // 'user_posts',
      // 'user_link',
      // 'user_status',
      // 'manage_pages',
      'pages_show_list',
      'read_insights',
      // 'pages_read_user_content',
      'pages_read_engagement',
    ];
    const url = `https://www.facebook.com/v20.0/dialog/oauth?client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&auth_type=rerequest&response_type=code&scope=${permissions.join(',')}`;
    window.location = url;
  }, []);

  const handleCopy = (value) => {
    if (navigator && navigator.clipboard) {
      navigator.clipboard.writeText(value).then(function () {
      }, function () {
        alert(t('Error copying to Clipboard. Try copying it manually!'));
      });
    } else {
      alert(t('Error copying to Clipboard. Try copying it manually!'));
    }
  };

  const handleReload = () => window.location.reload(false);

  useEffect(() => {
    (async () => {
      try {
        const code = extractFromUrl(KEY_AUTH_CODE);

        if (code) {
          const tokenUrl = `${API_URL}/token/exchange`;
          const params = {
            provider: 'facebook',
            code,
            redirectUri: REDIRECT_URI,
          };

          console.log(tokenUrl, params);

          const response = await axios.get(tokenUrl, { params });

          console.log(response.data);

          const {
            name,
            token,
            pic,
          } = response.data;

          try {

            const permissionsResponse = await axios.get(`${FACEBOOK_GRAPH_URI}/me/permissions`, {
              params: {
                access_token: token,
              }
            });

            console.log('permissions:', permissionsResponse.data)

            const pagesResponse = await axios.get(`${FACEBOOK_GRAPH_URI}/me/accounts`, {
              params: {
                access_token: token,
              }
            });

            console.log('pages:', pagesResponse.data);

            if (pagesResponse.data.data && pagesResponse.data.data.length > 0) {
              setUserPages(pagesResponse.data.data);
            } else {
              throw new Error('You have no pages authorized.');
            }

            setUserToken(token);
            setSuccess(true);
            setProfilePictureUrl(pic);
            setName(name);
          } catch (e) {
            console.log(e);
            setError(new Error('You haven\'t allowed DSPLAY to read your Facebook media.'));
          }
        } else {
          const error = extractFromUrl(KEY_ERROR);
          if (error) {
            const errReason = extractFromUrl(KEY_ERROR_REASON);
            const errDesc = extractFromUrl(KEY_ERROR_DESC);

            throw new Error(errReason === ERROR_USER_DENIED ? 'You have denied the required access.' : errDesc);
          }
        }
      } catch (e) {
        console.error(e);
        if (e.isAxiosError) {
          console.error('response:', e.response);
          if (e.response) {
            console.error(JSON.stringify(e.response.data, null, 2));
          }
        }

        setError(e);
      }
      setLoading(false)
    })();
  }, []);

  // console.log('loading:', loading, 'error:', error, 'token:', accessToken, 'username:', username);

  return (
    <TokenPresenter
      loading={loading}
      success={success}
      name={name}
      pictureUrl={profilePictureUrl}
      pages={userPages}
      error={error}
      onGenerate={handleOnGenerate}
      onCopy={handleCopy}
      onReload={handleReload}
    />
  );
}

export default Token;